export { Tag } from './tag.component';
